import axios from "axios";
import router from "../router.js";
// const host_localhost = "/assets/data";
const host_ngrok = "http://192.168.1.234:3000";
const host_aws_dev = "http://ec2-35-154-57-12.ap-south-1.compute.amazonaws.com";
//const host_stage_new_dev = "http://ec2-13-235-244-211.ap-south-1.compute.amazonaws.com:8082/v1";
const host_localhost = "http://192.168.1.218:3000";
//const uat_backend="http://13.233.227.66:8089/v1";

const host_stage_new_dev = process.env.VUE_APP_API_URL;
const host_stage_new_nestJs = process.env.VUE_APP_API_URL_NEST;
const host_new_report_url = process.env.VUE_APP_NEW_REPORTS_URL;
const host_hsbc_bank_url = process.env.VUE_APP_HSBC_API_URL;
const host_log_management_url = process.env.VUE_APP_LOGO_MANAGEMENT_URL;
const host_12BB_url = process.env.VUE_APP_12BB_URL;
const host_regenerate_url = process.env.VUE_APP_API_URL_GENERATE;
const host_letter_management = process.env.VUE_APP_LETTER_MANAGEMENT 

let token = localStorage.getItem("token") ?
    localStorage.getItem("token").replace(/(^"|"$)/g, "") :
    "";
let api_12bb_variables={
    host:host_12BB_url,
    SERVICE_12BB_URL:"/form-12BB-reports/addForm12BBReportEnc",
    SERVICE_12BB_UPDATE_URL:"/form-12BB-reports/update-form-12BB",
    SERVICE_ALLDOCUMENTS_URL:"/bulk-s3-report/fetchBulkITProofEnc",
    SERVICE_BULK_PAYSLIP_CATOGORY:"/bulk-s3-report/getListsForDropdown",
    SERVICE_BULK_PAYSLIP_DOWNLOAD:"/bulk-s3-report/generateSelectiveBulkReportEnc",
    SERVICE_EMPLOYEE_PAYROLL_MONTHS_ADDITIONAL_PAYSLIP:"/additional-payslip/fetchPaymentmonth",
    SERVICE_DOWNLOAD_ADDITIONAL_PAYSLIP:'/additional-payslip/fetch-add-paySlip',
    SERVICE_FORM_16_AVAILABLE_CHECK:'/form-16-reports/fetchForm16',
}
let api_variables = {
    host: host_stage_new_dev,
    // timeout: process.env.VUE_APP_TIMEOUT,
    SERVICE_PRESIGNED_URL :"/employee/presignedUrl",
    SERVICE_STATUTORY_SETTINGS_CHECK : "/onboarding_le/StatutoryInfoCheck/",
    SERVICE_FBP_CLAIMED_REPORT : "/employee/downloadFBPMonthlyClaimReport",
    SERVICE_FBP_UN_CLAIMED_REPORT : "/employee/downloadFBPAnnualDeclaredReport",
    SERVICE_FBP_UN_CLAIM : "/employee/unclaimedFbpData",
    SERVICE_FBP_DECLARATION_ESS:"/employee/fbpDeclarationMetaData",
    SERVICE_FBP_DECLARATION_ALL_DATA_ESS:"/employee/fetchDeclarationAllData",
    SERVICE_FBP_DECLARATION_DECLARE_ESS: "/employee/declareFbpDataESS",
    SERVICE_FBP_DECLARATION_CLAIMS_ESS: "/employee/claimDetails",
    SERVICE_FBP_DECLARATION_CLAIMS_HISTORY_ESS: "/employee/fbpClaimHistory",
    SERVICE_FBP_ADD_NEW_CLAIMS_ESS: "/employee/addClaim",
    SERVICE_FBP_COMPONENT_LIST:"/onboarding_le/getFbpEligibilityAllConfig", 
    SERVICE_FBP_DECLARE_POST:"/employee/fbpComponents",
    SERVICE_FBP_DECLARE_GET:"/employee/fbpComponentsInfo",
    SERVICE_FBP_DOWNLOAD_BULK_DECLARATION: "/onboarding_le/downloadFbpDeclareTemplate",
    SERVICE_FBP_UPLOAD_BULK_DECLARATION: "/employee/fbpDeclarationBulk",
    SERVICE_FBP_DOWNLOAD_BULK_CLAIMS: "/employee/fbpClaimBulkTemplate",
    SERVICE_FBP_UPLOAD_BULK_CLAIMS: "/employee/fbpClaimBulk/",
    SERVICE_FBP_LOCK:"/onboarding_le/fbpClaimLockUnlock",
    SERVICE_FBP_SLAB_ID:"/onboarding_le/getAllFbpEligibilityCtcConfig",
    SERVICE_CTCSLAB: "/onboarding_le/fbpctcslab",
    SERVICE_ORGANIZATION_INFO: "/onboarding_le/org",
    SERVICE_BUSSINESS_UNITS: "/onboarding_le/businessUnit",
    SERVICE_BU_TYPES: "/onboarding_le/businessUnitType",
    SERVICE_LEGAL_ENTITIES: "/onboarding_le/legalentity",
    SERVICE_ONBOARDING_STEPPER_STATUS: "/onboarding_le/stepperStatus",
    SERVICE_LOCATIONS: "/onboarding_le/location",
    SERVICE_FBP_SETTINGS: "/onboarding_le/fbpsetting",
    SERVICE_FBP_COMPONENTS: "/onboarding_le/fbp_component",
    SERVICE_LOCATION_TYPES: "/org/location_types",
    SERVICE_COST_CENTRES: "/onboarding_le/costCentre",
    SERVICE_COST_CENTRES_BULK_UPLOAD: "/bulk/costCentre_bulk",
    SERVICE_STATUTORY_INFO: "/org/statutory_info",
    SERVICE_SALARY_GRADES: "/onboarding_le/grade",
    SERVICE_SALARY_BANDS: "/onboarding_le/band",
    SERVICE_DESIGNATIONS: "/onboarding_le/designation",
    SERVICE_LEVELS: "/onboarding_le/level",
    SERVICE_PAYROLL_CYCLE: "/onboarding_le/payCycle",
    SERVICE_PAYROLL_COMPUTATION: "/org/pay_computation",
    SERVICE_DEPARTMENTS: "/onboarding_le/department",
    SERVICE_FBPLOCK_GET:"/onboarding_le/fbp_component_le", 
    SERVICE_EMPLOYEES_DATA: "/org/employeeFilter",
    SERVICE_SALARY_COMPONENT: "/onboarding_le/salary_component_le",
    SERVICE_PAY_COMPONENT_DETAILS:"/onboarding_le/salaryComponentReport",
    SERVICE_SALARY_STRUCTURE_DETAILS: "/onboarding_le/salary_structures",
    SERVICE_CALCULATE_SALARY: "/employee/calculatesalary",
    SERVICE_SALARY_COMPONENT_TYPES: "/org/salary_component_type",
    SERVICE_EMPLOYEE: "/employee/getallempdata",
    SERVICE_SAVE_EMPLOYEE: "/employee/createV11",
    SERVICE_GENERATE_CODE: "/employee/generateAutoEmployeeCode",
    SERVICE_BULK_UPLOAD_EMPLOYEE: "/employee/empBulkUpload",
    SERVICE_UPDATE_EMPLOYEE: "/employee/updateV11",
    SERVICE_GET_EMPLOYEE: "/employee/getEmployeeV11",
    SERVICE_GET_EMPLOYEE1: "/employee/getEmployeeV12",
    SERVICE_GET_EMPLOYEE_BY_ID: "/employee/getEmployeeByIdV10",
    SERVICE_GET_EMPLOYEE_BY_ORGID_NAME: "/onboarding_le/getReportingManagers",
    SERVICE_EMPLOYEE_BY_NAME: "/employee/search",
    SERVICE_EMPLOYEE_BY_LE_AND_NAME: "/employee/serachEmployeeByLEID",
    SERVICE_EMPLOYEE_INSTALLATION: "/employee/employeeInstallments",
    SERVICE_EMPLOYEE_TAXOUTSIDE_FETCH:"/employee/EmployeeTaxOutsideDetails",
    SERVICE_EMPLOYEE_TAXOUTSIDE_EDIT:"/employee/employeeTaxOutsideEdit",
    SERVICE_EMPLOYEE_TAXOUTSIDE_DELETE:"/employee/EmployeeTaxOutsideDelete/:id",
    SERVICE_EMPLOYEE_INSTALLMENTPATCH:"/employee/employeeInstallmentsUpdate",
    SERVICE_EMPLOYEE_NON_CTC_COMP: "/onboarding_le/salary_component_FixednonCTC",
    SERVICE_JOININGS_EXITS: "/payroll/run/joinings_exits",
    SERVICE_LOP_RLOP: "/employee",
    SERVICE_LOPRLOP_FILTER: "/employee/getAllLopRlopDataWithFilter",
    SERVICE_UPLOAD_LOP_RLOP: "/employee/util_lop",
    SERVICE_VIEW_LOP_RLOP: "/payroll/getByLEAll",
    SERVICE_PAYGROUP: "/onboarding_le/paygroup",
    SERVICE_SAVE_PAYGROUP: "/onboarding_le/paygroup",
    SERVICE_DEFAULT_PAYGROUP: "/onboarding_le/default_paygroup",
    SERVICE_ITDECLARATION_EMPL_DETAILS: "/org/employeeITDeclaration",
    SERVICE_ITDECLARATIONS_GET_EMPL: "/org/employeeFilter",
    SERVICE_REVISE_SALARY: "/employee/reviseSalary",
    SERVICE_GET_SALARY_REVISION: "/employee/salRevisionStatus",
    SERVICE_REVOKE_REVISE_SALARY: "/employee/revokeRevision",
    SERVICE_REVISE_SALARY_SEARCH_EMPLOYEE_NAME_CODE: "/employee/searchEmployeeSalRevision",
    SERVICE_FILTERED_REVISE_SALARY_EMPLOYEE: "/employee/getRevisionEmployee",
    SERVICE_GET_SEARCHED_EMPLOYEE: "/employee/searchRevisionEmployee",
    SERVICE_EMP_SALARYCOMPONENTS: "/employee/empSalaryComponents",
    SERVICE_PRIORITY_SALARYCOMPONENTS: "/onboarding_le/salary_component_le",
    SERVICE_EMP_CATEGORIES: "/onboarding_le/emp_category",
    SERVICE_FBP_ASSIGN: "/payroll/fbp/assign",
    SERVICE_GET_FBP: "/payroll/fbp",
    SERVICE_LEAVES_SALARY: "/payroll/legacydata",
    SERVICE_UPLOAD_LEGACY_DATA: "/payroll/legacydata_all",
    SERVICE_JVREPORTS: "/payroll/jv_report",
    SERVICE_IT_REPORTS: "/payroll/report/IT",
    SERVICE_CALCULATE_CTC: "/employee/salaryStructure",
    SERVICE_YTDSHEET:"/employee/ytdReport",
    //arushi
    SERVICE_EMP_SALARY_STRUCTURE: "/employee/ss",
    //end
    SERVICE_SALARY_COMPONENTS: "org/assign_salary_component",
    SERVICE_UPLOAD_FBP_CLAIMS: "/payroll/upload_fbp_claim",
    SERVICE_MONTHLY_PAYSLIP: "/onboarding_le/monthly_payslip",
    SERVICE_MONTHLY_PAYSLIP_PREVIEW: "/payslip/download/preview_payslip",
    SERVICE_FBP_CLAIMS: "/employee/fbp",
    SERVICE_SALARY_STRUCTURE: "/onboarding_le/salary_structure",
    SERVICE_SALARY_STRUCTURES: "/org/salarystructure",
    SERVICE_PROBATION_SETTINGS: "/onboarding_le/probationSettings",
    SERVICE_SMTP: "/org/smtp_configuration",
    SERVICE_VOLUNTARY_PF: "/org/vpfsetting",
    SERVICE_VOLUNTARY_PF_HISTORY: "/org/vpfEmpHistory",
    SERVICE_HOLD_SALARY: "/payroll/holdsalary",
    SERVICE_RELEASE_SALARY: "/payroll/releasesalary",
    SERVICE_PAYFREQUENCY: "/onboarding_le/payroll_cycle_payFrequencyList",
    SERFVICE_PAYDAYSINMONTH: "/onboarding_le/payroll_cycle_payDaysInMonthList",
    SERVICE_PF_SETTINGS: "/onboarding_le/statutory_info_pf",
    SERVICE_STATUTORY_IT: "/onboarding_le/statutory_info_it",
    SERVICE_STATUTORY_GRATUITY: "/onboarding_le/statutory_info_gratuity",
    SERVICE_STATUTORY_FORMSIXTEEN: "/onboarding_le/statutory_info_form16",
    SERVICE_STATUTORY_FORMTWENTYFOUR: "/onboarding_le/statutory_info_form24",
    SERVICE_GLOBAL_DATA: "/onboarding_le/globalData",
    SERVICE_INCREMENT_SETTINGS: "/onboarding_le/increment_settings",
    SERVICE_RETIREMENT_SETTINGS: "/onboarding_le/retirementsetting",
    SERVICE_FBP_BANDS: "/onboarding_le/fbpband",
    SERVICE_FILE_UPLOAD: "/file",
    SERVICE_SMTP_SETTINGS: "/onboarding_le/smtpsetting",
    SERVICE_PASSWORD_POLICY: "/onboarding_le/passwordpolicy",
    SERVICE_GET_PASSWORD_POLICY: "/onboarding_le/getPolicy",
    SERVICE_CONFIGURE_EVENTS: "/onboarding_le/event_configuration",
    SERVICE_RESET_PASSWORD: "/auth/adminResetPassword",
    SERVICE_SWITCH_ACTIVATE_FY: "/onboarding_le/financial_year",
    SERVICE_STATUTORY_BONUS: "/onboarding_le/statutory_bonus",
    SERVICE_SEARCH_EMP_USERLIST: "/auth/EmployeeUserlist",
    SERVICE_IMPORT_UDF: "/onboarding_le/udf",
    SERCIVE_GET_UDF: "/employee/getAllUdfAddEmployee",
    SERVICE_ITDECLARATION_EXEMPTION_CREATE: "/onboarding_le/createEmployeeExemption",
    SERVICE_ITDECLARATION_EXEMPTION_DELETE: "/onboarding_le/deleteEmployeeExemption",
    SERVICE_ITDECLARATION_EXEMPTION_GET: "/onboarding_le/listEmployeeExemption",
    SERVICE_ITDECLARATION_OTHERINCOME_CREATE: "/onboarding_le/createOtherIncome",
    SERVICE_ITDECLARATION_OTHERINCOME_GET: "/onboarding_le/listOtherIncome",
    SERVICE_ITDECLARATION_DEDUCTION_CREATE: "/onboarding_le/createEmployeeInvestmentPlanComponent",
    SERVICE_ITDECLARATION_DEDUCTION_GET: "/onboarding_le/listEmployeeInvestmentPlanComponent",
    SERVICE_ITDECLARATIONS_GET_PARTICULARS: "/onboarding_le/listInvestmentComponentType",
    SERVICE_DOWNLOAD_API: "/template/download/employeesalaryregister",
    SERVICE_EMPLOYEE_LEAVESINPUT: "/onboarding_le/employee_leave_input",
    SERVICE_UPLOAD_LOGO: "/logo/upload",
    SERVICE_UPLOAD_FBP:"/employee/uploadFbpClaimProof",
    SERVICE_FAVOURITE_ORG: "/onboarding_le/favourite_organisations",
    SERVICE_LOGIN_SETTINGS: "/onboarding_le/login_setting",
    SERVICE_FORM16: "form/upload/form_16",
    SERVICE_PAYSLIP: "/payslip/download/payslip_download",
    SERVICE_ITSHEET: "/itsheet/download/employeesalaryregister",
    SERVICE_FILTER_ORG: "/onboarding_le/search_organisation",
    SERVICE_EMP_EXITS: "/employee/resignee",
    SERVICE_SEARCH_EMP_NON_EXITS: "/employee/searchEmployeeFnf",
    SERVICE_FILTER_EMP_EXITS: "/employee/getResignedEmpListByFilter",
    SERVICE_VARIABLES: "/employee/empComponent",
    SERVICE_TDS: "/employee/empTdsOverride",
    SERVICE_RUN_PAYROLL: "/payroll",
    SERVICE_FETCH_GROSS_DETAILS: "/payroll/payrollSummaryMonth",
    SERVICE_GET_PAYROLL_STATUS: "/payroll/getLatestPayrollStatus",
    SERVICE_ADUIT_LOG_DETAILS: "/onboarding_le/getByLEMonthI",
    SERVICE_INSERT_DETAILS:"/onboarding_le/insertByLEMonthI",

    SERVICE_GET_LOCK_ACTIONS:"/onboarding_le/getByLEMonthLock",
    SERVICE_GET_COUNT_DETAILS:"/employee/paygroupDataV2/",

    SRVICE_POST_LOCK_ACTIONS:"/onboarding_le/insertByLEMonthLock",
    SERVICE_PATCH_LOCK_ACTIONS:"/onboarding_le/updateByLEMonthLock",
    SERVICE_ROLL_BACK:"/employee/rollbackInput",
    SERVICE_VALIDATION:"/onboarding_le/getDashboardValidateAfter",
    SERVICE_GET_BEFORE_VALIDATION:"/onboarding_le/getDashboardValidateBefore",
    SERVICE_EXACT_PAYCYCLE:"/payroll/exactCycle",

    SERVICE_FETCH_EMPBYID: "/employee/empdatabyid",
    SERVICE_PAYROLL_PAYGROUPS: "/employee/paygroupData",
    SERVICE_PAYROLL_SUMMARY: "/employee/payroll_summary",
    SERVICE_EMPLOYEE_REVISE_SALARY: "/employee/calculateReviseSalary",
    SERVICE_EMPLOYEES_NON_CTC: "/employee/nonCTCComponent",
    SERVICE_EMPLOYEES_BULK_NON_CTC: "/employee/bulkNonCTCImport",
    SERVICE_EMPLOYEES_SALARY_LIST: "/employee/nonCTC",
    SERVICE_EMPLOYEES_UPDATE_NON_CTC: "/employee/updateNonCTC",
    SERVICE_GET_LE_COMPONENTS: "/onboarding_le/salary_component_nonCTC",
    SERVICE_SALARY_COMPONENT_NON_CTC: "/onboarding_le/salary_component_nonCTC",
    SERVICE_UPDATE_NON_CTC: "/employee/updateNonCTC",
    SERVICE_EMPLOYEE_COMPONENTS_REVISION_LOG: "/employee/revisionLogs",
    SERVICE_HOLD_RELEASESALARY: "/employee/salaryStatusList",
    SERVICE_FNF: "/employee/fnf",
    SERVICE_FNF_GRATUITY_PAY: "/employee/calculateGratuity",
    SERVICE_FNF_GET_DATA: "/employee/fnfData",
    SERVICE_FNF_PENDING: "/employee/pendingFnf",
    SERVICE_FNF_PROCESSED: "/employee/processedFnf",
    SERVICE_FNF_CALCULATE_DAYS: "/employee/calculateFnfDays",
    SERVICE_RESET_FNF: "/employee/resetfnfData",
    SERVICE_HOLD_RELEASE_STOP: "/employee/updateStatus",
    SERVICE_ITDECLARATIONS: "/employee/itDeclarationData",
    SERVICE_PAYCOMPUTATION: "/onboarding_le/pay_computation",
    SERVICE_MAKE_ORGANISATION_FAV_UNFAV: "/auth/markUnMarkFavouriteOrganisation",
    // Reports Start
    SERVICE_REPORTS_SALARY_REGISTER: "/template/download/salaryregister",
    SERVICE_REPORTS_SALARY_REGISTER_TWO: "/template/download/salaryregisterv2",
    SERVICE_REPORTS_SALARY_REGISTER_THREE:"/template/download/salaryResgisterReportDownload",
    SERVICE_REPORTS_SALARY_REGISTER_TWO_NEW:"/download/payRegisterWithStd",
    SERVICE_REPORTS_CUSTOM_SALARY_REPORT: "/template/download/salaryReport",
    SERVICE_REPORTS_LOP: "/download/lop_report",
    SERVICE_REPORTS_CTC: "/download_ctc/ctc_report",
    SERVICE_REPORTS_VARIANCE: "/other_reports/va_report",
    SERVICE_REPORTS_JV: "/other_reports/jv_report",
    SERVICE_REPORTS_IT_COMPUTATION: "/onboarding_le/itComputationReport/",
    SERVICE_REPORTS_IT_COMPUTATION_NEW: "/onboarding_le/newItReport",
    SERVICE_REPORTS_PROCESS_DOWNLOAD:"/onboarding_le/itComputationReportDownload/",
    SERVICE_REPORTS_HC: "/employee/headCountReport",
    SERVICE_REPORTS_BA: "/other_reports/ba_report",
    SERVICE_REPORTS_BT: "/other_reports/bt_report",
    SERVICE_REPORTS_TDS: "/other_reports/tds_report",
    SERVICE_REPORTS_STATUTORY: "/other_reports/statutoryReport",
    SERVICE_REPORTS_FILTER: "/other_reports/reportModuleFilter",
    SERVICE_REPORTS_PAYROLL_SUMMARY: "/other_reports/payrollSummary_report",
    SERVICE_REPORTS_BANK_SUMMARY: "/other_reports/bankSummary_report",
    SERVICE_REPORTS_FORM16:"/onboarding_le/downloadEmployeeForm16",
    SERVICE_REPORTS_SALARY_REGISTER_SPECIFIC_EMPCODE: "/template/download/salaryregisterEmployees",
    SERVICE_REPORTS_IT_COMPUTATION_V2: "/downloads/itComputationReport/",
    // Reports End

    /************** Bulk Uploads Start **************/

    SERVICE_EMP_EXITS_UPLOAD_TEMPLATE: "/employee/bulkExitImport",
    SERVICE_FNF_UPLOAD_TEMPLATE: "/employee/bulkFNFImport",
    SERVICE_MONTHLY_TDS_UPLOAD_TEMPLATE: "/employee/bulkTDSImport",
    SERVICE_PAYMENT_DEDUCTION_UPLOAD_TEMPLATE: "/employee/empComponentBulkImport",
    SERVICE_EMPLOYEE_ARREAR_UPLOAD_TEMPLATE: "/employee/bulkArrear",
    SERVICE_DOWNLOAD_ARREAROVERIDES: "/employee/overRideCount",
    SERVICE_BUSSINESS_UNITS_UPLOAD_TEMPLATE: "/onboarding_le/bulkbusinessUnit",
    SERVICE_BUSSINESS_UNIT_TYPES_UPLOAD_TEMPLATE: "/onboarding_le/bulkbusinessUnitType",
    SERVICE_COST_CENTRE_UPLOAD_TEMPLATE: "/onboarding_le/bulkcostCentre",
    SERVICE_DEPARTMENT_UPLOAD_TEMPLATE: "/onboarding_le/bulkDepartments",
    SERVICE_DESIGNATIONS_UPLOAD_TEMPLATE: "/onboarding_le/bulkdesignation",
    SERVICE_LEVELS_UPLOAD_TEMPLATE: "/onboarding_le/bulklevel",
    SERVICE_SALARY_GRADES_UPLOAD_TEMPLATE: "/onboarding_le/bulkgrade",
    SERVICE_EMPLOYEE_CATEGORIES_UPLOAD_TEMPLATE: "/onboarding_le/bulkemployeeCategory",
    SERVICE_LOP_RLOP_UPLOAD_TEMPLATE: "/employee/bulklopimport",
    SERVICE_UPLOAD_TEMPLATE_ONSITE:"/employee/empOnsiteBulkUpload",  
    SERVICE_UPLOAD_TEMPLATE_TAXOUTSIDEPAYROLL:"/employee/employeeTaxOutsideUpload",
    SERVICE_DOWNLOAD_TEMPLATE_TAXAFTERPAYROLL:'/employee/EmployeeTaxOutsideTemplate',
    SERVICE_UPLOAD_TEMPLATE_INSTALLMENT:"/employee/employeeScheduledCompUpload", 
    SERVICE_UPLOAD_TEMPLATE_ARREAROVERRIDE:"/employee/bulkArrearImport",
    SERVIES_UPLOAD_TEMPLATE_WORKBASEDAYS: '/employee/empWorkBaseDaysBulkUpload',
    // SERVICE_IMPORT_UDF_UPLOAD_TEMPLATE: "/onboarding_le/bulkudf",
    SERVICE_IMPORT_UDF_UPLOAD_TEMPLATE: "/onboarding_le/createAdditionalFields",
    SERVICE_GET_ADDITIONAL_FIELDS_DATA: "/onboarding_le/additionalFields",
    SERVICE_GET_ADDITIONAL_FIELDS_DATA_NEW :"/onboarding_le/additionalFieldsForSalaryRegister",
    SERVICE_GET_ADDITIONAL_FIELDS_DATA_NEW :"/onboarding_le/additionalFieldsForSalaryRegister",
    SERVICE_EPLOYEE_UPLOAD_TEMPLATE:"/employee/downloademployeeTemplate",

    /************** Bulk Uploads End ****************/

    SERVICE_EMPLOYEE_SALARY_COMPONENTS: "/employee/empSalaryComponents",
    SERVICE_LEGACY_DATA_UPLOAD: "/legacyData/upload",

    /************** Employee Documents ************/
    SERVICE_EMPLOYEE_DOCUMENTS: "/employee/getAllEmployeeDocuments",
    SERVICE_EMPLOYEE_DOCUMENTS_ID: "/employee/getEmployeeDocumentById",
    SERVICE_EMPLOYEE_UPDATE_DOCUMENTS: "/employee/updateDocV11",
    SERVICE_EMPLOYEE_DELETE_DOCUMENTS: "/employee/removeEmployeeDocument",
    SERVICE_EMPLOYEE_UPLOAD_DOCUMENTS: "/employee/uploadEmployeeDocument",

    /******************Lock Payroll ****************/
    SERVICE_PAYROLL_LOCK_UNLOCK: "/payroll/lockUnlock",
    SERVICE_EMPLOYEE_COUNT: "/employee/headCount",
    SERVICE_LOP_COUNT:"/employee/lopReport",
    SERVICE_INSTALLMENT_COUNT:"/employee/ScheduledEarningReport",
    SERVICE_PERQ:"/employee/PerquisitesReport",
    SERVICE_NEWJOINERS_COUNT:"/employee/newJoineeReport",
    SERVICE_EXIT_COUNT:"/employee/exitReport",
    SERVICE_TDS_REPORT:"/employee/tdsReport",
    SERVICE_SAL_REV:"/employee/salaryRevisionReport",
    STD_GET_API:"/onboarding_le/getByLEMonthI",
    STD_INSERT_API:"/onboarding_le/insertByLEMonthI",
    STD_UPDATE_API:"/onboarding_le/updateByLEMonthI",
    PAYROLL_GET_API:"/onboarding_le/getByLEMonthPa",
    PAYROLL_INSERT_API:"/onboarding_le/insertByLEMonthPa",
    PAYROLL_UPDATE_API:"/onboarding_le/updateByLEMonthPa",
    PENDING_GET_API:"/onboarding_le/getByLEMonthPv",
    PENDING_INSERT_API:"/onboarding_le/insertByLEMonthPv",
    PENDING_UPDATE_API:"/onboarding_le/updateByLEMonthPv",
    TO_GET_DATE:"/payroll/exactCycle",
    PAN_FBP_ITDECL:"/employee/payrollValidate",
    // ----------------SWATHI API'S-------------------
    POPUP_EARNING_DEDUCTION:"/employee/earningDeductionInput",
    POPUP_SCHEDULEDEARNING_TAXOUTSIDE:"/employee/schedEarningAndTaxOutside",
    POPUP_PERQ_PAYROLL:"/employee/perquisitesPayrollInput",
    POPUP_LOPRLOP_PAYROLL:"/employee/lopRlopPayrollInput",
    POPUP_NEWJOINEE_EXIT:"/employee/newJoineeExitPayrollInput",
    SERVICE_VALIDATION:"onboarding_le/getDashboardValidateAfter",
    POPUP_SAL_REV:"/employee/salaryRevisionPayrollInput",
        // ----------------SWATHI API'S-------------------
    SERVICE_EMPLOYEES_TOTALPAY: "/employee/totalPay",
    SERVICE_PAYROLL_MONTH: "/payroll/lockPayroll",
    SERVICE_GET_PAYROLL_DETAILS: "/payroll/currentPayroll",
    SERVICE_RELEASE_PAYSLIP_ESS: "/payroll/setPayslipFlag",
    SERVICE_RELEASE_IT_SHEET_ESS: "/payroll/setITSheetFlag",
    SERVICE_PAYROLL_REPORT_GENERATION_FLAG: "/payroll/getPayrollStatusMonth",
    SERVICE_GET_CLIENT_ADMIN_PAYSLIP_MONTHS: "/employee/employeepayroll",
    SERVICE_GET_CLIENT_ADMIN_PAYSLIP_MONTHS_GLOBAL: "/employee/EmployeePayrollClientAdminGlobal",

    /************* Employee Profile *******************/
    SERVICE_EMPLOYEE_PROFILE: "/employee/employeeProfile",

    /**********************company policy****************************/
    SERVICE_COMPANY_POLICY:"/onboarding_le/le_company_policy",
    SERVICE_CHANGE_PASSWORD:"/auth/changePassword",
    /****************** Employee Directory ****************/
    SERVICE_EMPLOYEE_ACTIVE_EXIST: "/employee/employeeActivationStatus",

    /****************** Create ESS ****************/
    SERVICE_ENABLE_ESS: "/employee/enableESS",
    SERVICE_EMPLOYEE_LIST_ESS: "/employee/employeeList",
    SERVICE_ESS_LOGIN: "/auth/essLogin",
    SERVICE_EMPLOYEE_ITDASHBOARD: "/employee/calculateIt/",
    SERVICE_HOLIDAYLIST: "/employee/holidayList",
    SERVICE_BIRTHDAYS_LIST: "/employee/bDayList",
    SERVICE_EMPLOYEE_PAYROLL_MONTHS: "/employee/EmployeePayslip",
    SERVICE_EMPLOYEE_PAYROLL_MONTHS_FOR_IT_SHEET: "/employee/EmployeeITSheet",
    SERVICE_EMPLOYEE_COMPENSATION: "/employee/salaryStructure",

    /****************** Employee Salary Revision ****************/
    SERVICE_EMPLOYEE_SALARY_REVISION: "/employee/getRevisionByEmployee",

    /****************** Employee Salary Details ****************/
    SERVICE_EMPLOYEE_SALARY_DETAILS: "/employee/getEmployeeCTCBreackup",

    /****************** Hold and Release Salary ****************/

    SERVICE_STATUS_LIST :"/employee/status",
    SERVICE_STATUS_UPDATE:"/employee/status",
    SERVICE_BULK_UPLOAD:"/employee/bulkStatusImport",

    /****************** Manage User Roles ****************/
    SERVICE_ASSIGN_ROLE: "/auth/employeeAssignRole",
    SERVICE_GET_ROLES: "/employee/role",
    SERVICE_DEACTIVATE_USER: "/auth/deactivateUser",
    SERVICE_CHANGE_ROLE_PERMISSIONS: "/auth/editRolePermissions",

    /****************** Statutory Deduction Override ****************/
    SERVICE_STATUTORY_DEDUCTION_OVERRIDE: "/employee/deductionOverride",
    SERVICE_STATUTORY_DEDUCTION_OVERRIDE_BULK: "/employee/bulkDeductionOverride",

    /****************** Income Tax  ****************/
    SERVICE_CREATE_PLAN:"/employee/addItDeclarationPlan",
    SERVICE_GET_PLAN:"/employee/getItDeclaratoionPlanList",
    SERVICE_GET_IT_DATA:"/employee/itDeclarationData",
    CREATE_IT_PLAN_DATA:"/employee/itDeclarationData",
    ACTIVATE_PLAN:"/employee/updateItDeclarationPlan",
    SERVICE_GET_PLAN_ID:"/employee/getPlanByID",
    GET_ACTIVE_PLAN:"/employee/getActivePlan",
    UPLOAD_DECLARATION_FORM:"/itform/uploadForms/it_forms",
    IT_SERVICE_BULK_UPLOAD:"/employee/empITBulkUpload",
    SERVICE_IT_PROOF_BULK_DOWNLOAD: "/onboarding_le/downloadITApprovalTemplate",
    SERVICE_DOWNLOAD_IT_DECLARATION_DETAILS: "/onboarding_le/downloadITData",
    SERVICE_DOWNLOAD_IT_SUBMISSION_DETAILS: "/employee/getITProofReport",
    SERVICE_DOWNLOAD_IT_PROOF_DETAILS: "/onboarding_le/downloadITProofData",
    SERVICE_DOWNLOAD_IT_PROOF_SUBMITTED_DETAILS: "/onboarding_le/downloadITSubmittedProofReport",
    SERVICE_IT_PROOF_BULK_UPLOAD: "/employee/empITProofBulkUpload",

    /****************** Form 24Q  ****************/
    SERVICE_FORM_24Q: "/onboarding_le/form24q",
    SERVICE_FORM_24Q_UPDATE: "/onboarding_le/form_24Q",
    SERVICE_FORM_24Q_CREATE: "/onboarding_le/form_24Q",

    /****************** Form 24 Acknowledgement  ****************/
    SERVICE_UPLOADED_ACKNOWLEDGEMENTS: "/onboarding_le/form24Ack",
    SERVICE_UPLOADED_ACKNOWLEDGEMENTS_BY_QUARTER: "/onboarding_le/form24Ack",
    SERVICE_UPLOADED_ACKNOWLEDGEMENTS_DELETE: "/onboarding_le/deleteForm24QAck",

    /****************** Feed  ****************/
    SERVICE_FEED_CREATE: "/onboarding_le/announcement",
    SERVICE_FEED_GET: "/onboarding_le/announcement",
    /****************** Form 16 servie  ****************/
    SERVICE_FORM16_UPLOAD: "/form/upload/form_16/add",
    SERVICE_LIST_FROM16:"/onboarding_le/uploadForm16",

    /****************** My Team  ****************/
    SERVICE_MY_TEAM_GET: "/employee/getreporteesDetails",

    /****************** Bulk Edit Master Data  ****************/
    SERVICE_BULK_EDIT_MASTER_DATA_DOWNLOAD: "/employee/empbulkTemplate",
    SERVICE_BULK_EDIT_MASTER_DATA_UPLOAD: "/employee/emp_bulk",

    /****************** payroll lop_rlop  ****************/
    SERVICE_CREATE_LOP_RLOP:"/employee/createpayrollloprlop",
    SERVICE_GET_MONTH_LOP_RLOP:"/employee/getLopRlop",
    SERVICE_ONSITE_EMPLOYEE:"/employee/onsiteDaysBulkTemplate", 
    SERVICE_ARREAROVERRIDE_EMPLOYEE:"/employee/arrearOverrideTemplate",
    SERVICE_INSTALLMENT_EMPLOYEE:'/employee/EmployeeScheduledCompTemplate',
    /****************** TDS override bulk  ****************/
    SERVICE_TDS_BULK_UPLOAD:"/employee/bulkTDSOverride",

    /************************* workdays/basedays download API  ******************/
    SERVICE_DOWNLOAD_WORKBASEDAYS_TEMPLATE: '/employee/workBaseDaysTemplate',

    /****************** Income Tax Enable  ****************/
    SERVICE_IT_ENABLE:"/onboarding_le/statutory_info_enableITsetting",

    /****************** Create User Account ****************/
    SERVICE_CREATE_USER_ACCOUNT:"/auth/addAccount",
    SERVICE_GET_USER_LIST:"/auth/Userlist",
    SERVICE_USER_ACTIVATE:"/auth/activateUser",
    SERVICE_USER_DEACTIVATE:"/auth/deactivateUser",
    SERVICE_EDIT_ROLE_PERMISSION:"/auth/editRolePermissions",
    SERVICE_GET_SEARCH_EMPLOYEE: "/auth/searchEmployee",
    //SERVICE_FORGOT_PASSWORD_USER:"/auth/setPassword",

    /****************** List of Organisation and Legal entity ****************/
    SERVICE_GET_ORG_LEGAL_LIST:"/onboarding_le/getLEdetailsByOrgId",
    /**************** Generic Template Download Endpoint ****************/
    SERVICE_TEMPLATE_DOWNLOAD:"/onboarding_le/downloadTemplate/",
    SERVICE_IT_TEMPLATE_DOWNLOAD:"/onboarding_le/downloadITTemplate/",

    /****************** Income Tax Dependent ****************/
    SERVICE_GET_DEPENDENTS:"/employee/getDependents",
    SERVICE_CREATE_DEPENDENTS:"/employee/createDependents",
    SERVICE_DEPENDENTS_DELETE: "/employee/deleteDependents",
    SERVICE_DEPENDENTS_UPDATE: "/employee/updateDependents",

    /****************** Employee Reports ****************/ 
    SERVICE_REPORTS_EMPLOYEE:"/employee/employeeReport",
    SERVICE_ANNUAL_SALARY_REPORT:"/employee/employeeSalaryReport",

    /****************** Add New Claim ****************/ 
    SERVICE_CREATE_NEW_CLAIM:"/employee/fbpClaimCreate",
    SERVICE_UPDATE_NEW_CLAIM:"/employee/fbpClaimUpdate",
    SERVICE_GET_LIST_NEW_CLAIM:"/employee/list",
    SERVICE_UPLOAD_PROOF_NEW_CLAIM:"/employee/fbpUploadProof",
    SERVICE_GET_LISTONE_NEW_CLAIM_ID:"/employee/listOne",
    SERVICE_GET_FBP_COMPONENT_LIST:"/onboarding_le/fbp_reimbursement_comp",
    SERVICE_GET_FBP_COMPONENT_LIST_DATA:"/employee/fbpComponentsBySlabId",

    // FBP Eligibility CTC Config 
    SERVICE_ADD_FBP_ELIGIBILITY_CONFIG:"/onboarding_le/addUpdateFbpEligibilityCtcConfig",
    SERVICE_GET_FBP_ELIGIBILITY_CONFIG:"/onboarding_le/getAllFbpEligibilityCtcConfig",
    SERVICE_DELETE_FBP_ELIGIBILTY_CONFIG:"/onboarding_le/RemoveEligibilityCtcConfig",
    SERVICE_GET_FBP_COMPONENTS: "/onboarding_le/fbp_component_le",
    SERVICE_GET_BY_LE_ID: "/onboarding_le/getFbpEligibilityAllConfig",

    //Approve/View Approved Claims
    SERVICE_FBP_CLAIM_DATA: "/employee/fbpClaimMonth",
    SERVICE_FBP_APPROVE_CLAIM: "/employee/fbpClaimUpdate",
    
    /****************** Process monthly FBP ****************/ 
    SERVICE_CREATE_RUN_FBP_PROCESS:"/employee/runFbpProcess",
    SERVICE_CREATE_RUN_FBP_PROCESS_FOR_ALL:"/employee/runFbpProcessForAll",
    SERVICE_CREATE_RUN_FBP_GET:"/onboarding_le/fbpClaimLockUnlock",

    /***************** Fbp Unclaimed Reimbursement *****************/
    SERVICE_CLAIMED_FBP_LIST: "/employee/claimedFbpList",
    SERVICE_UPDATE_UNCLAIMED_AMOUNT: "/employee/fbpUnclaimUpdate",
    
    /****************** Push FBP Configuration ****************/ 
    SERVICE_CREATE_PUSH_FBP:"/onboarding_le/pushFbpSetting",

    /****************** Salary Revision Bulk Upload ****************/ 
    SERVICE_SALARY_REVISION_DOWNLOAD:"/employee/downloadSalRevisionBulk",
    SERVICE_SALARY_REVISION_BULK_UPLOAD:"/employee/bulkSalRevision",

    /******************* Salary Revision Deletion *******************/
    SERVICE_SALARY_REVISION_DELETION_DOWNLOAD: "/employee/salaryRevisionDeletionTemplate",
    SERVICE_SALARY_REVISION_DELETION_UPLOAD: "/employee/salaryRevisionDeletion",

    /******Process FNF Bulk upload ******/
    SERVICE_DOWNLOAD_FNF_TEMPLATE:"/employee/fnfBulkTemp",
    SERVICE_UPLOAD_FNF_TEMPLATE:"/employee/bulkfnfimport",
    SERVICE_DOWNLOAD_FNF_REVOKE_TEMPLATE: "/employee/revokeFNFTemplate",
    SERVICE_UPLOAD_FNF_REVOKE_TEMPLATE: "/employee/revokeFNFBulk",

    /****************** Enhancement New Earning and Deduction Api ****************/ 
    SERVICE_DOWNLOAD_EARNING_DEDUCTION_TEMPLATE:"/employee/earningAndDeductionBulkImport",
    SERVICE_UPLOAD_EARNING_DEDUCTION_TEMPLATE:"/employee/bulkEarningAndDeductionImport",

    /****************** Import UDF Download Api ****************/
    // SERVICE_DOWNLOAD_IMPORT_UDF_TEMPLATE:"/onboarding_le/downloadUDFTemplate",
    SERVICE_DOWNLOAD_IMPORT_UDF_TEMPLATE: "/onboarding_le/additionFieldsTemplate",
    

    /****************** Bulk Employee Code Download Api ****************/
    SERVICE_DOWNLOAD_EMPLOYEE_CODE_TEMPLATE:"/onboarding_le/empBulkTemp",
    SERVICE_DOWNLOAD_EMPLOYEE_PROXY:"/auth/signinproxy",
    SERVICE_EMPLOYEE_CODE_BULK_UPLOAD:"/onboarding_le/empBulkTempImport",
    /****************** Standard Report Download Api ****************/
    SERVICE_DETAILED_PF_REPORT: "/download/pfDetailedReport",
    SERVICE_PT_REPORT: "/download/ptreport/",
    SERVICE_LWF_REPORT: "/download/lwfreport",

    /****************** Perquisites ****************/
    SERVICE_GET_PERQUISITES: "/onboarding_le/getPerksByLE",
    SERVICE_CREATE_PERQUISITES_COMPONENT: "/onboarding_le/addPerkToLE/",
    SERVICE_UPDATE_PERQUISITES_COMPONENT: "/onboarding_le/updatePerkOnLE/",
    SERVICE_DELETE_PERQUISITES_COMPONENT: "/onboarding_le/deletePerkFromLE/",
    SERVICE_MAP_TO_EMPLOYEE_DOWNLOAD_TEMPLATE: "/employee/perquisitesBulkUpload/",
    SERVICE_MAP_TP_EMPLOYEE_UPLOAD_TEMPLATE: "/employee/perquisiteBulkUpload/",

    SERVICE_EXIT_EMP_TEMPLATE: "/employee/exitEmployeeBulkTemplate",

    /****************** Selected Bulk Employee List Upload and Download Paroll Api ****************/
    SERVICE_DOWNLOAD_EMPLOYEE_LIST_PAYROLL_TEMPLATE:"/employee/payrollForSelectedEmployees",
    SERVICE_EMPLOYEE_LIST_PAYROLL_BULK_UPLOAD:"/employee/payrollForSelectedEmployees",
    SERVICE_OFF_PAYROLL_SUMMARY_DATA: "/employee/payroll_Summary_OffCycle",

    SERVICE_UPDATE_GRATUITY_AMOUNT: "/employee/updateGratuityAmount",
    SERVICE_VPF_GET:"/employee/getVPFDetails/",
    SERVICE_VPF_POST:"/employee/updateVPFDetails",
    SERVICE_NPS_GET:"/employee/getNPSDetails",
    SERVICE_NPS_POST:"/employee/updateNPSDetails",
    SERVICE_REPORT_DATA_TRANSFER: "/employee/transferRecords",
    SERVICE_ESS_BULK_LOGIN_DOWNLOAD_TEMPLATE: "/employee/essTemplate",
    SERVICE_ESS_BULK_LOGIN_UPLOAD_TEMPLATE: "/employee/bulkEss",
    SERVICE_DELETE_REVISED_SALARY:"/employee/deleteSalary",
    SERVICE_ESS_PASSWORD_RESET:"/auth/resetEssPassword",
    SERVICE_IT_PROOF_SUBMITION_FETCH_ALL:"/employee/getEmpProofSubmission/",
    SERVICE_IT_PROOF_SUBMISSION_POST_ALL:"/employee/empProofSubmission/",
    SERVICE_IT_PROOF_ADMIN_RELEASE:"/employee/auditApprove",
    SERVICE_IT_PROOF_UPLOAD_S3_BUCKET:"/employee/uploadITProof/",
    SERVICE_IT_PROOF_DELETE_FILE_IN_S3_BUCKET:"/employee/deleteProof/",
    SERVICE_IT_PROOF_RELEASE_INCORPARATION_FETCH_DATA: "/employee/getStatusHeadCount",
    SERVICE_IT_PROOF_RELEASE_DECLARATION_FLAG: "/employee/declarationFlag",
    SERVICE_IT_PROOF_INCORPORATE_DECLARATION:"/employee/incorporateDeclaration",
    SERVICE_SELECT_ALL_PAYROLL: "/onboarding_le/getDashboardValidateAll",
    SERVICE_PAYLIEF_ESS: "/auth/payliefEss",
    SERVICE_PAYROLL_REPORT_LOGS:"/onboarding_le/payrollReportLogs",
    SERVICE_IT_PROOF_EMPLOYEE_WISE_DOWNLOAD:"/employee/proofSubmissionWindowReport",
    SERVICE_IT_PROOF_EMPLOYEE_WISE_UPLOAD:"/employee/proofSubmissionWindowReportUpload",
    SERVICE_STD_FREEZE: "/payroll/getStatutoryReports",
    SERVICE_NPS_REPORT: "/employee/npsReport",
    SERVICE_SALARY_IT_REPORT_DOWNLOAD_CHECK_ON_PAYROLL:'/onboarding_le/salaryReportsStatus',
    SERVICE_ESS_IT_DECLARATION_IT_SHEET:'/payroll/getItSheetData',
    SERVICE_TAX_COMPARE:'/payroll/getTaxBasedOnRegime',
    SERVICE_DOWNLOAD_BANK_REPORT: "/employee/bankReport",
};

let api_nest_variables = {
    host: host_stage_new_nestJs,
    SERVICE_RELEASE_FORM_SIXTEEN: "/client-report-mapping/send-email",
    SERVICE_DOWNLOAD_NEW_PAYSLIP: "/payslip-reports/fetchPayslipEnc",
    SERVICE_DOWNLOAD_NEW_ITSHEET: "/itsheet-reports/fetchItEnc",
    SERVICE_DOWNLOAD_CTC_REPORT_NEW: "/ctc-reports/fetchctcEnc",
    SERVICE_DOWNLOAD_CTC_REPORT: "/ctc-reports/fetch-ctc-report",
    SERVICE_UPDATE_CTC_STATUS: "/ctc-reports/updateApproveStatus",
    SERVICE_SHARE_EMP_DATA:"/fetchReport",
    SERVICE_CTC_DATA:"/ctc-reports/fetch-ctc-admin-enc",
    SERVICE_FNF_PAYSLIP: "/fnf-payslip-reports/fetchFnFPayslipByIdEnc",
    SERVICE_BULK_PAYSLIP:"/bulk-s3-report/generateBulkReportEnc",
    SERVICE_BULK_PAYSLIP_DETAILS: "/bulk-s3-report/fetchBulkReportsEnc",
    SERVICE_BULK_PAYSLIP_DATA:"/bulk-s3-report/fetchBulkReportsByIdEnc",
    SERVICE_FNF_POPUP:"/fnf-payslip-reports/fetchFnFPayslipMonthsEnc",
    SERVICE_UPLOAD_PREVIOUS_PAYSLIPS_ITSHEET: "/upload-documents",
    
    SERVICE_GET_UPLOAD_LOGS: "/getBulkUploadLogs",
    SERVICE_UPLOAD_FORM_GENERAL:"/form-16-reports/upload-form16",  /* upload for form 16 */
    SERVICE_GET_FORM_LOGS: "/form-16-reports/getBulkUploadLogs/",  /*get form logs for table */
    SERVICE_GET_DOWNLOAD_FORM:"/form-16-reports/getBulkUploadLogFile/", /*downloading button table for form 16 */
    SERVICE_GET_UPLOAD_PRESIGNED_URL:"/getPresignedUrl",
    SERVICE_FORM_REPORT_DOWNLOAD:"/form-16-reports/fetchForm16Enc",
        
    SERVICE_GET_DOWNLOAD_GENERAL:"/general-documents/getBulkUploadLogFile/",  /*downloading button table for general */
    SERVICE_ESS_DOWNLOAD_GENERAL:"/general-documents/fetchGeneralDocumentsEnc",
    SERVICE_GET_DOCUMENT_LIST:"/general-documents/get-document-list",  /*get documnet list for drop down */
    SERVICE_ADD_DOCUMENT_LIST:"/general-documents/add-document-list",  /*add document name in the list*/
    
    SERVICE_GET_GENERAL_LOGS: "/general-documents/getBulkUploadLogs/",  /*get general logs for table */
    // SERVICE_UPLOAD_FORM_GENERAL:"/form-16-reports/upload-form16",  /* upload for form 16 */
    SERVICE_UPLOAD_GENERAL: "/general-documents/upload-general-documents",  /*upload for general */
    SERVICE_DOWNLOAD_REPORTS:"/downloadReports",
    SERVICE_CLEAR_TAX_FORM_16_INTEGRATION:"/form-16-reports/clearTaxIntegration",

};
 let api_hsbc_account_variables ={
     host: host_hsbc_bank_url,
     SERVICE_HSBC_ADD_ACCOUNT_DETAILS: "/client-account-details/create-client-account-details",
     SERVICE_HSBC_PAYMENT_INITIATE: "/credit-transactions/add-credit-transaction",
     SERVICE_HSBC_PAYMENT_APPROVED:"/batch/findAll",
     SERVICE_HSBC_PAYMENT_STATUS:"/credit-transactions/update-credit-transaction"
 };
 let api_hsbc_payment_initiate = {
    host:host_stage_new_nestJs,
    SERVICE_HSBC_PAYMENT_DETAILS: "/payment-query-details/fetchDetails"
 };
  
 let api_log_managment_variable ={
    host:host_log_management_url,
    SERVICE_LOG_MANAGEMENT_DETAILS: "/logs/findAll",
    SERVICE_LOG_MANAGEMENT_APPLICATION_NAMES: "/logs/find-app-and-tag-names"
 }

let api_new_report_variables ={
    host: host_new_report_url,
    SERVICE_ESI_REPORT: "/download/esiReport",
    SERVICE_DOWNLOAD_MONTH_VARIANCE: "/download/currentLastMonthVarianceReport/",
    SERVICE_DOWNLOAD_ACTIVE_EMPLOYEES: "/downloads/active_employee/",
    SERVICE_DOWNLOAD_NEGATIVE_SALARY: "/downloads/negativeSalaryReport/",
    SERVICE_DOWNLOAD_ZERO_SALARY: "/downloads/zeroSalaryReport/",
    SERVICE_DOWNLOAD_EMPLOYEE_MASTER: "/downloads/employeeMasterReport/",
    SERVICE_DOWNLOAD_PAN_NOT_AVAILABLE: "/downloads/panNotAvblReport/",
    SERVICE_DOWNLOAD_IT_RECONCILIATION: "/download/it_reconciliation/",
    SERVICE_DOWNLOAD_INCOME_TAX: "/downloads/incomeTaxReport/",
    SERVICE_DOWNLOAD_TDS_REPORT: "/downloads/tdsReport/",
    SERVICE_DOWNLOAD_ETDS_REPORT: "/downloads/etdsReport/",
    SERVICE_DOWNLOAD_YTD_TDS_REPORT: "/downloads/ytdtdsReport/",
    SERVICE_DOWNLOAD_CTC_REPORT: "/download/ctcReport/",
    SERVICE_DOWNLOAD_FNF_REPORT:"/download/fnfreport/",
    SERVICE_DOWNLOAD_SALARY_ON_HOLD:"/download/salaryOnHold/",
    SERVICE_DOWNLOAD_SALARY_VARIANCE: "/download/salaryVariance/",
    SERVICE_DOWNLOAD_COST_CENTER_REPORT:"/downloads/costcenter_report/",
    SERVICE_PT_REPORT: "/download/ptreport/",
    SERVICE_LWF_REPORT: "/downloads/lwfreport/",
    SERVICE_DETAILED_PF_REPORT: "/downloads/pfDetailedReport/",
    SERVICE_PF_REPORT: "/downloads/pfReport/",
    SERVICE_ESI_V2_REPORT:"/downloads/esiDetailedReport/",
    SERVICE_LWF_V1_REPORT: "/downloads/lwfDetailedReport/",
    SERVICE_IT_COMPUATION_REPORT: "/downloads/itComputationReport/",
    SERVICE_SALARY_REGISTER_REPORT: "/downloads/consolidated_salary_register_report/",
    SERVICE_COST_CENTER_WISE_REPORT: "/downloads/CostCenterWise_report/",
    SERVICE_CUMULATIVE_SALARY_RIGISTER_REPORT: "/downloads/cumulative_salary_register_report/",
    SERVICE_HEAD_COUNT_REPORT:"/downloads/HeadCount_report/",
    SERVICE_MASTER_SALARY_REPORT: "/downloads/master_salary_report/",
    SERVICE_ONE_TIME_PAYMENT_REPORT: "/downloads/one_time_payment_report/",
    SERVICE_EMPLOYEE_MASTER_COLUMNS_REPORT: "/downloads/employeeMasterReport/",
    SERVICE_FFS_SALARY_REGISTER_REPORT:"/downloads/ffsSalaryRegisterReport/",
    SERVICE_MASTER_CTC_REPORT: "/downloads/masterCTCReport/",
    SERVICE_PENDING_FNF_REPORT: "/downloads/pendingFnfReport/",
    SERVICE_IT_RECONCILIATION_DETAILED_REPORT:"/download/it_reconciliationDetails/",
    SERVICE_BANK_ADVICE_CONSOLIDATED_REPORT: "/download/bankAdviceConsolidateReport",
    SERVICE_BANK_ADVICE_WITH_IFSC_BANK_WISE_REPORT:"/download/bankAdviceWithIFSCBankWise",
    SERVICE_PAY_REGISTER_STANDARD_REPORT:"/download/payRegisterWithStd",
    SERVICE_REPORTS_GET_PATTERN:"/download/getPattern",
    SERVICE_PAY_REGISTER_WITHOUT_STANDARD_REPORT:"/download/payRegisterWithOutStd/",
    SERVICE_DOWNLOAD_STD_EMPLOYEE_MASTER:"/downloads/empMaster/",
    SERVICE_DOWNLOAD_OVERRIDE_REPORTS:"/download/empComponentMonthwiseReport/",
    SERVICE_DOWNLOAD_BULK_REPORTS:"/v1/employee/downloadAllReports",
}

let api_regenerate_report_variables = {
    host: host_regenerate_url,
    SERVICE_GENERATE_PAYROLL_REPORTS: "/paylief-helper/genrateReport",
    SERVICE_GENERATE_IT_SHEET_EXCEL: "/paylief-helper/itSheetExcelDownload"
}

let api_letter_management = {
    host: host_letter_management,
    SERVICE_LETTER_TEMPLATES: "/letter-management/templates",
    SERVICE_TEMPLATE_DETAILS: "/letter-management/template-details",
    SERVICE_CSV_TEMPLATE: "/letter-management/csv-template",
    SERVICE_UPLOAD_CSV: "/letter-management/upload-csv",
    SERVICE_DELETE_REQUEST: "/letter-management/delete-request",
    SERVICE_PROCESS_LETTER: "/letter-management/process-letter",
    SERVICE_PROCESS_SELECTED_LETTERS: "/letter-management/process-selected-letters",
    SERVICE_BULK_DOWNLOAD: "/letter-management/bulk-download",
    SERVICE_BULK_DOWNLOAD_ZIP: "/letter-management/bulk-download-zip",
}

/*
Author : Vinod
Issue : Not getting data, after logging in with same credential from different systems.
Date: 18/03/2020
Search_string: PL_2952
 */

/*
Author: Vinod
Date: 19/03/2020
Issue Description: After session time out, if we are logging in with different credential also, we are redirecting to previous user LE screen, from where it was session timed out.
search_string: PL_2925
*/

// global Error handler based on the status code
const errorHandler = error => {
    if (error) {
        switch (error.data.statusCode) {
            case 422:
                {
                    return error.data.message;
                }
            case 409:
                {
                    return error.data.message;
                }
            case 404:
                {
                    return error.data.message;
                }
            case 413:
                {
                    return error.data.message;
                }
            case 401:
                {
                    // PL_2952
                    // try {
                    window.localStorage.removeItem("token");
                    let previousUrl = router.currentRoute.path; // PL_2925
                    router.push({
                        path: "/signin",
                        query: { entry_url: previousUrl }
                    });
                    return error.data.message;
                    // } catch (err) {
                    //     return error.data.message;
                    // }
                }
            default:
                return error.data.message;
        }
    }
};

const errorLogSheet = error => {
    if (error) {
        switch (error.data.statusCode) {
            case 412:
                {
                 return error.data;
                }
            default:
                return error.data;
        }
    }
}

const get_axios_instance = rpath => {
    return axios.create({
        baseURL: `${api_variables.host}${rpath}`,
        timeout: api_variables.timeout,
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    });
};
const get_axios_instance_12bb = rpath =>{
    return axios.create({
        baseURL:`${api_12bb_variables.host}${rpath}`,
        timeout: api_variables.timeout,
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })
};
const get_axios_instance_absolute_path = rpath => {
    return axios.create({
        baseURL: `${rpath}`,
        timeout: api_variables.timeout,
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    });
};

// "Content-Type": "multipart/form-data",
// "Accept":"multipart/form-data",
const get_axios_file_download_instance = rpath => {
    return axios.create({
        baseURL: `${api_variables.host}${rpath}`,
        timeout: api_variables.timeout,
        responseType: "blob",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    });
};
const get_axios_file_instance = rpath => {
    return axios.create({
        baseURL: `${api_variables.host}${rpath}`,
        // timeout: api_variables.timeout,
        headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`
        }
    });
};
const get_axios_file_instance_12BB = rpath => {
    return axios.create({
        baseURL: `${api_12bb_variables.host}${rpath}`,
        // timeout: api_variables.timeout,
        headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`
        }
    });
};
// This variable is used to download payslip 
const get_axios_file_download_payslip_instance = rpath => {
    return axios.create({
        baseURL: `${api_variables.host}${rpath}`,
        timeout: api_variables.timeout,
        // responseType: "blob",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    });
};

const get_axios_nest_instance = rpath => {
    return axios.create({
        baseURL: `${api_nest_variables.host}${rpath}`,
        //timeout: api_variables.timeout,
        // responseType: "blob",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    });
};

const get_axios_nest_regenerate_instance = rpath => {
    return axios.create({
        baseURL: `${api_regenerate_report_variables.host}${rpath}`,
        //timeout: api_variables.timeout,
        // responseType: "blob",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    });
};

const get_axios_report_instance = rpath => {
    return axios.create({
        baseURL: `${api_new_report_variables.host}${rpath}`,
        //timeout: api_variables.timeout,
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    });
};

const get_axios_hsbc_instance = rpath => {
return axios.create({
    baseURL: `${api_hsbc_account_variables.host}${rpath}`,
    headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
    }
});
};
 
const get_axios_log_management = rpath =>{
    return axios.create({
        baseURL: `${api_log_managment_variable.host}${rpath}`,
        headers:{
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    });
};
const get_axios_hsbc_instance_payment_details = rpath => {
    return axios.create({
        baseURL: `${api_hsbc_payment_initiate.host}${rpath}`,
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    });
    };
// Letter Management Functions
const get_axios_letter_instance = (rpath) => {
    return  axios.create({
        baseURL: `${api_letter_management.host}${rpath}`,
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    });
};

const cancelSource = axios.CancelToken;
export {
    get_axios_log_management,
    api_log_managment_variable,
    get_axios_instance,
    get_axios_instance_absolute_path,
    api_variables,
    cancelSource,
    errorHandler,
    get_axios_file_instance,
    get_axios_file_instance_12BB,
    get_axios_file_download_instance,
    get_axios_file_download_payslip_instance,  // This variable is added for download payslip
    errorLogSheet,
    api_nest_variables,
    api_12bb_variables,
    get_axios_instance_12bb,
    api_new_report_variables,
    get_axios_nest_instance,
    get_axios_report_instance,
    api_hsbc_account_variables,
    api_hsbc_payment_initiate,
    get_axios_hsbc_instance,
    get_axios_hsbc_instance_payment_details,
    get_axios_nest_regenerate_instance,
    api_regenerate_report_variables,
    api_letter_management,
    get_axios_letter_instance,
};
